module.exports = __webpack_public_path__ + "img/vincent_s.1800889a.png";